// @flow
export const SWITCH_THEME_API = {
  root: '',
  input: '',
  switch: '',
  thumb: '',
  label: '',
  disabled: '',
  checked: ''
};
